let nameMap = {
  '营销目标': 'landing_type',
  '应用名称': 'app_name',
  '应用标记': 'sublabel',
  '创建日期': 'create_time',
  '预算类型': 'budget_mode',
  '广告位置': 'inventory_type',
  '首个图片名称': 'image_name',
  '创意制作类型': 'creative_mode',
  '优化目标': 'marketing_target',
  '转化跟踪名称': 'convert_name',
  '定向包': 'target_tag',
  '创意组名称': 'creative_group_name',
  '标题包名称': 'creative_title',
  '投放范围': 'delivery_range',
  '首个视频名称': 'vedio_name',
}
let apiMap = {
  'landing_type': '营销目标',
  'app_name': '应用名称',
  'sublabel': '应用标记',
  'create_time': '创建日期',
  'budget_mode': '预算类型',
  'inventory_type': '广告位置',
  'image_name': '首个图片名称',
  'creative_mode': '创意制作类型',
  'marketing_target': '优化目标',
  'convert_name': '转化跟踪名称',
  'target_tag': '定向包',
  'creative_group_name': '创意组名称',
  'creative_title': '标题包名称',
  'delivery_range': '投放范围',
  'vedio_name': '首个视频名称',
}

const showDataToApi = (str) => {
  if (str) {
    let newStr = str.replace(/{(.*?)}/g, function (node, key) {
      return '{' + (nameMap[key] || key) + '}';
    })
    return newStr;
  } else {
    return ''
  }
}

const apiDatatoShow = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function (node, key) {
    return '{' + (apiMap[key] || key) + '}';
  })
  return newStr;
}

export default {
  showDataToApi,
  apiDatatoShow
}